export default __webpack_public_path__ + "static/media/TAWI.cff917b7.png";